'use client';

import React from 'react';
import { useForwardSearchParams } from '../../hooks/navigation/useForwardSearchParams';
import {
  AE_PRICING_LINK_ABSOLUTE,
  ButtonLink,
  LinkWithArrow,
  READ_THE_SCIENCE_LINK_METABOLIC_SCORE,
} from '../shared';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './MetabolicApp.module.css';

const metabolicDevicesImg = getCompressedAssetUrl('/m1/home-metabolic-app.png');

export const MetabolicApp = ({
  hideRequestAccess,
}: {
  hideRequestAccess?: boolean;
}) => {
  const forwardParams = useForwardSearchParams();
  return (
    <div className={`${styles.container} u-grid`}>
      <div className={styles.content}>
        <h3 className={styles.title}>
          Make daily progress by maximising your real-time Metabolic Score
        </h3>
        <div className={styles.buttons}>
          {!hideRequestAccess && (
            <ButtonLink
              className={styles.buttonLink}
              href={forwardParams(AE_PRICING_LINK_ABSOLUTE)}
              rel="noopener noreferrer"
              size="m"
            >
              Buy now
            </ButtonLink>
          )}
          <LinkWithArrow
            className={styles.linkArrow}
            href={READ_THE_SCIENCE_LINK_METABOLIC_SCORE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read the Science
          </LinkWithArrow>
        </div>
      </div>
      <div
        className={styles.img}
        style={
          {
            ['--app-img']: `url('${metabolicDevicesImg}')`,
          } as React.CSSProperties
        }
      />
    </div>
  );
};
